import { getPnLClass } from '@/utils/formatting';
export function pnlColor(value) {
    const cls = getPnLClass(value);
    if (cls === 'positive')
        return 'text-emerald-400';
    if (cls === 'negative')
        return 'text-red-400';
    return 'text-gray-500';
}
//# sourceMappingURL=tw.js.map